import appSettings from 'wanderu-config';

import EventQueue from './EventQueue';

function debug(context, ...args) {
    _addEvent('debug', context, args);
}

function log(context, ...args) {
    _addEvent('log', context, args);
}

function info(context, ...args) {
    _addEvent('info', context, args);
}

function warn(context, ...args) {
    _addEvent('warn', context, args);
}

function error(context, ...args) {
    _addEvent('error', context, args);
}

function event(context, ...args) {
    _addEvent('event', context, args);
}

function _addEvent(level, context, args) {
    const metadata = args.splice(-1)[0];

    let data = args.length > 1
        ? args[1]
        : null;

    if (typeof (data) === 'string') {
        data = {
            message: data,
        };
    }

    if (data instanceof Error) {
        data = {
            message: data.message,
            stack: data.stack,
        };
    }

    if (appSettings.env.isClient) {
        metadata.clientUrl = document.location.toString();
    }

    const additionalInfo = args.splice(2);

    EventQueue.enqueueEvent({
        event: `${level}:${context}:${args[0]}`,
        data: {
            ...data,
            additionalInfo,
            metadata,
        },
        event_timestamp: Date.now(),
    });
}

export default {
    debug,
    log,
    info,
    warn,
    error,
    event,
};
